import api from "./base-api"

const tohSocialApi = api.injectEndpoints({
    endpoints: (build) => ({
        isCheaterV1Toh: build.query({
            query: (userId) => `v1/toh/cheaters/${userId}`,
            providesTags: ["toh-cheater"]
        }),
        banV1Toh: build.mutation({
            query: ({ userId, reason }) => ({
                url: `v1/toh/cheaters/${userId}/ban`,
                method: "POST",
                body: reason
            }),
            invalidatesTags: ["toh-cheater"]
        }),
        unbanV1Toh: build.mutation({
            query: ({ userId, reason }) => ({
                url: `v1/toh/cheaters/${userId}/unban`,
                method: "POST",
                body: reason
            }),
            invalidatesTags: ["toh-cheater"]
        }),
        grantAmnestyV1Toh: build.mutation({
            query: ({ userId, reason, expiresAt }) => ({
                url: `v1/toh/cheaters/${userId}/amnesty`,
                method: "POST",
                body: { reason, expiresAt }
            }),
            invalidatesTags: ["toh-cheater"]
        }),
        revokeAmnestyV1Toh: build.mutation({
            query: ({ userId }) => ({
                url: `v1/toh/cheaters/${userId}/amnesty`,
                method: "DELETE"
            }),
            invalidatesTags: ["toh-cheater"]
        })
    }),
    overrideExisting: false
})

export const {
    useIsCheaterV1TohQuery,
    useBanV1TohMutation,
    useUnbanV1TohMutation,
    useGrantAmnestyV1TohMutation,
    useRevokeAmnestyV1TohMutation
} = tohSocialApi
